import { createContext as t } from "react";
const e = t(void 0);
export {
  e as F
};
//# sourceMappingURL=field-context-CFgvjLYL.mjs.map
